import { useEffect, useState } from 'react';

function useMediaQuery(query) {
    const [matches, setMatches] = useState(window.matchMedia(query).matches);

    useEffect(() => {
        const mq = window.matchMedia(query);

        mq.addEventListener('change', onMediaQueryChange);

        function onMediaQueryChange(e) {
            setMatches(e.matches);
        }

        return () => {
            mq.removeEventListener('change', onMediaQueryChange);
        };
    }, [query]);

    return matches;
}

export { useMediaQuery };
